import {
    AppConfigFactory,
    APP_CONFIG,
    TranslateService,
} from '@icc/shared';
import { Injectable, Inject } from '@angular/core';
import { WindowActiveConfiguration, DoorActiveConfiguration } from '@icc/window-door/types';
import { ActiveSash } from '@icc/window-door/types';
import { WindowFacade } from '../+state/window-door.facade';

@Injectable()
export class PanelOptionsFacade {
    loadedData = false;

    constructor(
        private translateService: TranslateService,
        private windowFacade: WindowFacade,
        @Inject(APP_CONFIG) private config: AppConfigFactory
    ) {}

    init() {
        this.loadedData = true;
    }

    panelGlazingBox(
        conf: DoorActiveConfiguration | WindowActiveConfiguration,
        filling: ActiveSash['panelGlazing']
    ) {
        let img = null;
        const title = this.translateService.instant('DOOR|Szklenie:');
        let name = this.translateService.instant('INTERFACE|Brak');
        let u = this.translateService.instant('INTERFACE|brak danych');

        if (filling) {
            img = '/files/filling/' + filling.image;

            name = filling.name;
            if (this.config().IccConfig.Configurators.showFillingsProducers) {
                name += ` (${filling.producer})`;
            }
            if (filling.u) {
                u = filling.u + ' W/m2*K';
            }
        }
        return {
            img,
            title,
            name,
            u,
        };
    }

}
